import React, { useState } from "react";
import "../css/activityTabs.css";
import "../css/hpcParentAssessment.css";

const ActivityTabs = ({ lstActivity, activityId, setActivityId }) => {


    const handleClick = (id) => {
        setActivityId(id);
    }
    const handleTouchStart = (id) => {
        if (handleClick.timer) {
            clearTimeout(handleClick.timer);
            delete handleClick.timer;
        }

        handleClick.timer = setTimeout(() => handleClick(id), 300);
    };

    return (
        <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 col-centered padding-remove">
            <div className="parent-activity-tabs" >
                {lstActivity && lstActivity.map((activity) => (
                    <div
                        key={activity.activityId}
                        className={activity.activityId === activityId ? "parent-activity-tab-active" : "parent-activity-tab"}
                        onClick={() => handleClick(activity.activityId)}
                        onTouchStart={() => handleTouchStart(activity.activityId)}
                    >
                        <a className="nav-link">{activity.activity}</a>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ActivityTabs;